import usersIcon from '../../../../assets/images/icons/logicmanager/users.png';
import modulesIcon from '../../../../assets/images/icons/logicmanager/modules.png';
import schoolsIcon from '../../../../assets/images/icons/logicmanager/schools.png';
import classesIcon from '../../../../assets/images/icons/logicmanager/classes.png';
import reportsIcon from '../../../../assets/images/icons/logicmanager/reports.png';
import coursesIcon from '../../../../assets/images/icons/logicmanager/courses.png';
import logicMaker from '../../../../assets/images/icons/logicmanager/logicmaker.png';
import equipe from '../../../../assets/images/icons/logicmanager/Equipe.png';
import questionarioPesquisa from '../../../../assets/images/icons/logicmanager/Questionário de Pesquisa.png';
import relatorioGeral from '../../../../assets/images/icons/logicmanager/Relatório Geral.png';
import logoSite from '../../../../assets/images/icons/logicmanager/Logo Site.png';
import quizMaker from '../../../../assets/images/icons/logicmanager/Quizmaker.png';
import relatorioAcessos from '../../../../assets/images/icons/logicmanager/Relatório de Acessos.png';
import gerenciarFeedbacks from '../../../../assets/images/icons/logicmanager/Gerenciar Feedbacks.png';
import gerenciarEventos from '../../../../assets/images/icons/logicmanager/Gerenciar Eventos.png';
import publi from '../../../../assets/images/icons/logicmanager/Publicações.png';
import start from '../../../../assets/images/icons/logicmanager/start.png';
import perguntas from '../../../../assets/images/icons/logicmanager/perguntas.png';
import banco from '../../../../assets/images/icons/logicmanager/banco.png';
import som from '../../../../assets/images/icons/logicmanager/som.png'
import atalho from '../../../../assets/images/icons/logicmanager/atalho.png'
import dataTeste from '../../../../assets/images/icons/logicmanager/dataTeste.png'
import relatorioTeste from '../../../../assets/images/icons/logicmanager/relatorioTeste.png'
import { Permission } from '../../../../types';

export interface EditComponent {
    id: number;
    name: string;
    icon: string;
    route: string;
    permission: Permission;
    level: number;
}

export const EDIT_COMPONENTS: EditComponent[] = [
    {
        id: 1,
        name: 'Gerenciamento de instituições',
        icon: schoolsIcon,
        route: '/manager/edit/schools',
        permission: 'logicmanager.classes',
        level: 1
    },
    {
        id: 2,
        name: 'Gerenciamento de cursos',
        icon: coursesIcon,
        route: '/manager/edit/courses',
        permission: 'logicmanager.admin',
        level: 1
    },
    {
        id: 3,
        name: 'Gerenciamento de turmas',
        icon: classesIcon,
        route: '/manager/edit/classes',
        permission: 'logicmanager.classes',
        level: 1
    },
    {
        id: 4,
        name: 'Gerenciamento de usuários',
        icon: usersIcon,
        route: '/manager/edit/users',
        permission: 'logicmanager.admin',
        level: 1
    },
    {
        id: 5,
        name: 'Gerenciamento da equipe',
        icon: equipe,
        route: '/manager/edit/equipe',
        permission: 'logicmanager.admin',
        level: 2
    },
    {
        id: 7,
        name: 'Geração de relatório',
        icon: reportsIcon,
        route: '/manager/report',
        permission: 'logicmanager.classes',
        level: 1

    },
    {
        id: 8,
        name: 'Relatório de Pesquisa Mega+',
        icon: questionarioPesquisa,
        route: '/manager/questionario',
        permission: 'logicmanager.admin',
        level: 1

    },
    {
        id: 9,
        name: 'Geração de relatório geral',
        icon: relatorioGeral,
        route: '/manager/generalReport',
        permission: 'logicmanager.classes',
        level: 1

    },
    {
        id: 10,
        name: 'Mudar logo website',
        icon: logoSite,
        route: '/manager/logo',
        permission: 'logicmanager.admin',
        level: 2
    },
    {
        id: 11,
        name: 'Gerenciar eventos',
        icon: gerenciarEventos,
        route: '/manager/events',
        permission: 'logicmanager.admin',
        level: 2
    },
    {
        id: 12,
        name: 'Gerenciar publicações',
        icon: publi,
        route: '/manager/publications',
        permission: 'logicmanager.admin',
        level: 2
    },
    {
        id: 13,
        name: 'Gerenciar feedbacks',
        icon: gerenciarFeedbacks,
        route: '/manager/feedback',
        permission: 'logicmanager.admin',
        level: 2
    },
    {
        id: 14,
        name: 'QuizMaker',
        icon: quizMaker,
        route: '/manager/quiz',
        permission: 'logicmanager.admin',
        level: 3
    },
    {
        id: 15,
        name: 'Logic Maker',
        icon: logicMaker,
        route: 'LogicMaker',
        permission: 'logicmanager.classes',
        level: 1
    },
    {
        id: 16,
        name: 'Modulos',
        icon: modulesIcon,
        route: 'logicmakerModules',
        permission: 'logicmanager.classes',
        level: 1
    },
    {
        id: 17,
        name: 'Gerenciamento de feedbacks',
        icon: gerenciarFeedbacks,
        route: '/manager/feedbacks',
        permission: 'logicmanager.admin',
        level: 1
    },
    {
        id: 18,
        name: 'Configurações questionário',
        icon: relatorioAcessos,
        route: '/manager/configTeste',
        permission: 'logicmanager.admin',
        level: 3
    },
    {
        id: 19,
        name: 'Data do segundo teste',
        icon: dataTeste,
        route: '/manager/segundoTeste',
        permission: 'logicmanager.classes',
        level: 3
    },
    {
        id: 20,
        name: 'Editar perguntas',
        icon: perguntas,
        route: '/manager/configPerguntas',
        permission: 'logicmanager.classes',
        level: 4
    },
    {
        id: 21,
        name: 'Começar jogo',
        icon: start,
        route: '/manager/game',
        permission: 'logicmanager.classes',
        level: 4
    },
    {
        id: 22,
        name: 'Banco de questões',
        icon: banco,
        route: '/manager/bancoQuestoes',
        permission: 'logicmanager.admin',
        level: 4
    },
    {
        id: 23,
        name: 'Edição efeitos sonoros',
        icon: som,
        route: '/manager/efeitosSonoros',
        permission: 'logicmanager.admin',
        level: 4
    },
    {
        id: 24,
        name: 'Relatório do teste de pensamento computacional',
        icon: relatorioTeste,
        route: '/manager/pc',
        permission: 'logicmanager.admin',
        level: 3
    },
    {
        id: 25,
        name: 'Ver teste de pensamento computacional',
        icon: atalho,
        route: '/pc',
        permission: 'logicmanager.admin',
        level: 3
    }
];
